import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Lock, AlertCircle } from "lucide-react";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await adminLogin(form);
      localStorage.setItem("admin_token", res.token);
      navigate("/admin");
    } catch {
      setError("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F4] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-[#1C2B3A] flex items-center justify-center mx-auto mb-4">
            <Lock size={22} className="text-[#B8945A]" />
          </div>
          <h1 className="font-serif text-2xl font-bold text-[#1C2B3A]" data-testid="admin-login-title">Admin Dashboard</h1>
          <p className="font-sans text-sm text-[#7A7A7A] mt-1">Sign in to manage your portfolio</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-lg border border-[#E5DDD3] p-6 space-y-4">
          <div className="space-y-2">
            <Label className="font-sans text-sm text-[#1C2B3A]">Email</Label>
            <Input
              data-testid="admin-email-input"
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="admin@abhilash.com"
              className="border-[#E5DDD3] focus-visible:ring-[#B8945A]/20"
            />
          </div>
          <div className="space-y-2">
            <Label className="font-sans text-sm text-[#1C2B3A]">Password</Label>
            <Input
              data-testid="admin-password-input"
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="Enter password"
              className="border-[#E5DDD3] focus-visible:ring-[#B8945A]/20"
            />
          </div>
          {error && (
            <div className="flex items-center gap-2 text-red-600 text-sm font-sans" data-testid="admin-login-error">
              <AlertCircle size={14} /> {error}
            </div>
          )}
          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-[#1C2B3A] hover:bg-[#2A3F54] text-white font-sans text-sm tracking-wider h-10"
          >
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
